import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito experiencia previa?',
    a: 'No. IA Express 2026 está diseñado para principiantes y explicado de forma clara, práctica y fácil de seguir.'
  }, {
    q: '¿Necesito una computadora?',
    a: 'No necesariamente. El enfoque está pensado para que puedas empezar desde tu celular.'
  }, {
    q: '¿Esto es muy técnico?',
    a: 'No. El contenido fue creado para evitar tecnicismos innecesarios y ayudarte a avanzar de forma simple.'
  }, {
    q: '¿Puedo hacerlo aunque todavía tenga mi trabajo actual?',
    a: 'Sí. De hecho, está pensado para personas con poco tiempo que necesitan una forma realista de comenzar.'
  }, {
    q: '¿Voy a saber qué ofrecer?',
    a: 'Sí. El programa te ayuda a entender cómo estructurar una oferta clara y accionable.'
  }, {
    q: '¿En cuánto tiempo puedo empezar?',
    a: 'La meta es ayudarte a lanzar la base de tu mini-negocio visual en 48 horas, siguiendo el proceso paso a paso.'
  }, {
    q: '¿Esto garantiza ingresos?',
    a: 'No. Ningún programa serio debería prometer resultados garantizados. Tus resultados dependerán de tu acción, implementación y constancia. Lo que sí obtienes es una ruta mucho más clara, estratégica y práctica para comenzar.'
  }];
  return <section className="bg-cream py-20 md:py-32" data-id="element-53">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-55">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-56">
            Preguntas frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-57">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} index={index} data-id="element-58" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer,
  index
}: {
  question: string;
  answer: string;
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay: index * 0.1
  }} className="bg-white border border-slate-200 rounded-2xl overflow-hidden shadow-sm" data-id="element-59">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-60">
        <span className="font-bold text-navy text-lg pr-4" data-id="element-61">{question}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} className="shrink-0 text-gold" data-id="element-62">
          <ChevronDownIcon className="w-6 h-6" data-id="element-63" />
        </motion.div>
      </button>

      <AnimatePresence data-id="element-64">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-65">
            <div className="p-6 pt-0 text-slate-600 leading-relaxed border-t border-slate-50 mt-2" data-id="element-66">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}